export default "__VITE_ASSET__Dnd7Fenx__"